module.exports = __webpack_public_path__ + "static/media/betaDisabled.56a43f64.svg";